import { NextPage } from 'next'

import { Page } from 'src/components/layouts/Page'
import { MonitoringReport } from 'src/components/organisms/MonitoringReport'

import { withAuthRequired } from 'src/utils/auth'

const ApplicationMonitoringPage: NextPage = () => {
  return (
    <Page title='Monitorings'>
      <MonitoringReport />
    </Page>
  )
}

export default withAuthRequired(ApplicationMonitoringPage)
